// Loader.jsx
import React from 'react';

const Loader = () => {
  return (
    <div style={styles.backdrop}>
      <div style={styles.spinner}></div>
    </div>
  );
};

const styles = {
  backdrop: {
    position: 'fixed',
    top: 0, left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(255,255,255,0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  spinner: {
    width: '60px',
    height: '60px',
    border: '8px solid #eee',
    borderTop: '8px solid #4caf50',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
};

// Add keyframes globally in CSS or use a styled-component solution
// @keyframes spin {
//   0% { transform: rotate(0deg); }
//   100% { transform: rotate(360deg); }
// }

export default Loader;
